// ---------- CPF/CNPJ: normalização, máscara e validação de dígito ----------
// Extraído de Empresas.jsx (Fase 3 / Bloco B, ajuste final item 2) para os
// Ajustes Finais de Acabamento da V1, item 1 — a consulta automática por
// CNPJ no cadastro de Clientes reaproveita exatamente esta mesma
// normalização/validação, em vez de duplicá-la numa segunda implementação
// paralela. O tipo do documento é detectado pela quantidade de dígitos,
// nunca por um campo/seletor separado.
export const onlyDigits = (v) => String(v || "").replace(/\D/g, "");

export const maskDocumento = (v) => {
  const d = onlyDigits(v).slice(0, 14);
  if (d.length <= 11) {
    return d
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return d
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
};

export const docType = (v) => {
  const len = onlyDigits(v).length;
  if (len === 11) return "cpf";
  if (len === 14) return "cnpj";
  return null;
};

const cpfCheckDigit = (base) => {
  let s = 0;
  for (let i = 0; i < base.length; i++) s += parseInt(base[i], 10) * (base.length + 1 - i);
  const r = s % 11;
  return r < 2 ? "0" : String(11 - r);
};
export const isValidCPF = (v) => {
  const d = onlyDigits(v);
  if (d.length !== 11 || /^(\d)\1{10}$/.test(d)) return false;
  const d1 = cpfCheckDigit(d.slice(0, 9));
  const d2 = cpfCheckDigit(d.slice(0, 9) + d1);
  return d[9] === d1 && d[10] === d2;
};

const cnpjCheckDigit = (base) => {
  const weights = base.length === 12 ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2] : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  let s = 0;
  for (let i = 0; i < base.length; i++) s += parseInt(base[i], 10) * weights[i];
  const r = s % 11;
  return r < 2 ? "0" : String(11 - r);
};
export const isValidCNPJ = (v) => {
  const d = onlyDigits(v);
  if (d.length !== 14 || /^(\d)\1{13}$/.test(d)) return false;
  const d1 = cnpjCheckDigit(d.slice(0, 12));
  const d2 = cnpjCheckDigit(d.slice(0, 12) + d1);
  return d[12] === d1 && d[13] === d2;
};

export const isValidDocumento = (v) => {
  const t = docType(v);
  if (t === "cpf") return isValidCPF(v);
  if (t === "cnpj") return isValidCNPJ(v);
  return false;
};
